export default __webpack_public_path__ + "static/media/watch_icon.75f2e4b2.svg";